export const DEFAULT_CUSTOMER_REFERENCE_LABEL = 'Customer Reference Number';

export const resolveCustomerReferenceLabel = (source) => {
  const label = source?.customerReferenceLabel;
  if (typeof label !== 'string') {
    return DEFAULT_CUSTOMER_REFERENCE_LABEL;
  }

  const trimmed = label.trim();
  return trimmed.length > 0 ? trimmed : DEFAULT_CUSTOMER_REFERENCE_LABEL;
};
